/**
 * ? @description : Audio Pending Teachers List
 */

// Dependencies
import React, { Fragment, useEffect, useState, memo } from "react";
import {
  Stack,
  List,
  ListItem,
  ListItemText,
  Avatar,
  ListItemAvatar,
  Typography,
  Alert,
  Chip,
  Box,
} from "@mui/material";

//redux
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/features/appSlice";

//Axios
import Axios from "../../../../axios/Axios";
import axios from "axios";
import '../../../../css/Dashboard.css'

function AudioPending() {

  const dispatch = useDispatch();
  const [pendingAudioList, setPendingAudioList] = useState([]);

  // TODO : Random Color Generation
  // function randomColor() {
  //   let letters = "0123456789ABCDEF";
  //   let color = "#";

  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }

  //   return color;
  // }
  
  //Get Request to fetch audio pending teacher list
  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      try{
        const options = {
          method: "get",
          url: `dashboard/pendingteacherlist`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };
  
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );
        if(response.status === 200){
          setPendingAudioList(response.data)
        }
      }catch(error){
        // console.log(error);
        if(!axios.isCancel(error)){
          dispatch(
            showSnackbar({
              message: "Couldn't able to retrieve pending audio teachers list",
              severity: "error",
            })
          ); }
      }
    })()
    return () => {
      controller.cancel();
  }
  },[dispatch])
  // console.log(pendingAudioList);
  return (
    <Fragment>
      <Typography variant="h6" component="div" color="primary">
        Audio Pending List ({pendingAudioList.length})
      </Typography>

      <Stack className="audioPendingList">
        {pendingAudioList.length !== 0 ? pendingAudioList?.map((teacher, index) => {
          return (
            <List key={index}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar/>
                </ListItemAvatar>
                <ListItemText primary={<Box sx={{display: "flex", justifyContent: "space-between"}}>{teacher.teacher_name}{<Chip color="primary" size="small" label={teacher.audio_status}/>}</Box>}  />
              </ListItem>
            </List>
          );
        }):
        <Alert
         severity="info"
         sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          mt: "30%",
          backgroundColor: "inherit"
         }}
        >
          No Data Available
        </Alert>
      }
      </Stack>
    </Fragment>
  );
}

export default memo(AudioPending);
